import { render, staticRenderFns } from "./ContactFormulierSuccess.vue?vue&type=template&id=40d7c885&"
import script from "./ContactFormulierSuccess.vue?vue&type=script&lang=js&"
export * from "./ContactFormulierSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports